export const CREATE = 'CREATE';
export const FETCH_ALL = 'FETCH_ALL';
export const DELETE = 'DELETE';
export const UPDATE = 'UPDATE';
export const LIKE_BLOG = 'LIKE_BLOG';

export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';

export const FETCH_REVIEWS = 'FETCH_REVIEWS';
export const ADD_REVIEW = 'ADD_REVIEW';
export const DELETE_REVIEW = 'DELETE_REVIEW';

export const categories = [
    'Smartphones', 
    'Washing Machines', 
    'Refrigerators',
    'Air Conditioners',
    'Television',
    'Kitchen Appliances',
    'Laptop & PC',
    'Mobile Accessories',
    'Camera & DSLR',
    'Printer',
    'Gaming Consoles',
    'Storage Devices'
];
